import useStore from "../../../store"
import { WizardPictureStep } from "../../ui/wizard"

export default function NAPPicture({ title }) {
  const image = useStore((state) => state.NAPImages[title])
  const nextStep = useStore((state) => state.nextStep)
  const setNAPImages = useStore((state) => state.setNAPImages)
  const NAPImages = useStore((state) => state.NAPImages)
  const setCurrentStep = useStore((state) => state.setCurrentStep)
  const editingNapPhoto = useStore((state) => state.editingNapPhoto)
  const setEditingNapPhoto = useStore((state) => state.setEditingNapPhoto)
  const NAPWorkflowLength = useStore((state) => state.NAPWorkflowLength)

  const handleNextStep = () => {
    if (editingNapPhoto) {
      setCurrentStep(NAPWorkflowLength - 2)
    } else {
      nextStep()
    }
    setEditingNapPhoto(false)
  }

  const handleSubmit = (image) => {
    if (image) {
      const reader = new FileReader()

      reader.onloadend = () => {
        setNAPImages({...NAPImages, [title]: reader.result})
      }

      reader.readAsDataURL(image)
    }

    handleNextStep()
  }

  return(
    <WizardPictureStep
      title={title}
      previewable={true}
      handleSubmit={handleSubmit}
      image={image}
    />
  )
}